import { Signal } from '@angular/core';
import { Observable } from 'rxjs';

export abstract class AppLifecycleService {
  abstract readonly isActive: Signal<boolean>;
  abstract readonly resumed$: Observable<void>;
  abstract init(): void;
}
